// extracted by mini-css-extract-plugin
export var readonly = "_fo-1";
export var star = "_fo-0";